import { render, staticRenderFns } from "./RadioMenu.vue?vue&type=template&id=221fa53d&scoped=true&"
import script from "./RadioMenu.vue?vue&type=script&lang=js&"
export * from "./RadioMenu.vue?vue&type=script&lang=js&"
import style0 from "./RadioMenu.vue?vue&type=style&index=0&id=221fa53d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221fa53d",
  null
  
)

export default component.exports